<template>
  <div>
    <v-row class="mx-1">
      <v-col cols="12">
        <v-card class="px-2 py-2 rounded-lg" id="card-custom">
          <!-- <v-row>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Satker"
                :items="units2"
                v-model="unit2"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_2_id"
                @change="changeUnit(2)"
                @click:clear="changeUnit(2)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Bagian"
                :items="units3"
                v-model="unit3"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_3_id"
                @change="changeUnit(3)"
                @click:clear="changeUnit(3)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Sub Bagian"
                :items="units4"
                v-model="unit4"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_4_id"
                @change="changeUnit(4)"
                @click:clear="changeUnit(4)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    placeholder="Bulan"
                    append-icon="event"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" type="month" locale="id" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="$refs.menu.save(date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-menu
                v-model="menuDateCreated"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateCreatedText"
                    placeholder="Pilih Tanggal"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    @click:clear="dateCreated = []"
                    append-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateCreated"
                  locale="id"
                  no-title
                  range
                />
              </v-menu>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-autocomplete
                placeholder="Jenis Catatan"
                :items="types"
                v-model="filter.kd_catatan"
                outlined
                dense
                hide-details
                clearable
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Status"
                :items="statusList"
                v-model="filter.status"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="12" xs="12">
              <v-text-field
                v-model="filter.search"
                placeholder="Cari"
                outlined
                dense
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="py-0"
            >
              <v-card-actions class="pa-0">
                <v-spacer />
                <v-btn
                  color="#FBB005"
                  class="px-10"
                  @click="getListRequestUpdate"
                >
                  <span class="subtitle-2 text-capitalize">Cari</span>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="py-0"
            >
              <v-card-actions class="pa-0">
                <!-- <v-btn
                  text
                  class="text-capitalize caption headline-color"
                  color="secondary"
                  @click="isArchive = !isArchive"
                  >{{ isArchive ? "Kembali" : "Lihat Arsip"
                  }}<v-icon class="ml-2" color="secondary">{{
                    isArchive ? "list" : "archive"
                  }}</v-icon></v-btn
                > -->
                <v-btn
                  text
                  class="text-capitalize caption headline-color"
                  color="primary"
                  @click="handleCreate"
                  >Tambah Catatan<v-icon class="ml-2" color="primary"
                    >add_circle</v-icon
                  ></v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
          <v-data-table
            id="table-custom"
            class="mt-2"
            multi-sort
            :headers="headers"
            :items="notes"
            :loading="loading"
            :options.sync="options"
            :server-items-length="totalItem"
            :footer-props="{
              'items-per-page-options': rowsPerPageItems
            }"
            loading-text="Loading... Please wait"
            v-model="selected"
            :show-select="selection"
            item-key="no"
          >
            <template v-slot:[`item.bulan`]="{ item }">
              <span
                >{{ item.bulan | dateMonthDisplay }}
                {{ item.bulan | dateYear }}</span
              >
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon small @click="handleEdit(item)" color="primary"
                ><v-icon small>edit</v-icon></v-btn
              >
              <v-btn icon small @click="handleDelete(item)" color="primary"
                ><v-icon small>delete</v-icon></v-btn
              >
            </template>
            <template v-slot:no-data>
              <ContentNotFound message="Data capaian kerja tidak ada" />
            </template>
          </v-data-table>
          <v-card-actions v-if="selected.length > 0">
            <p class="subtitle-2 font-weight-regular ma-3 headline-color">
              {{ selected.length }} TERPILIH
            </p>
            <v-btn
              small
              outlined
              color="#717171"
              class="mx-2 px-5 text-capitalize"
              @click="handleDelete(null, true)"
              >Hapus</v-btn
            >
            <!-- <v-btn
              small
              outlined
              color="#717171"
              class="mx-2 px-5 text-capitalize"
              @click="handleMultiArchive"
              >{{ isArchive ? "Pulihkan" : "Arsipkan" }}</v-btn
            > -->
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <CatatanBulkDialog ref="catatanBulk" @on-refresh="getListRequestUpdate" />
  </div>
</template>
<script>
import PublicService from "@/services/resources/public.service";
import AttendanceService from "@/services/resources/attendance.service";
const ContentNotFound = () => import("@/components/Content/NotFound");
const CatatanBulkDialog = () => import("@/components/Dialog/CatatanBulk");

export default {
  components: {
    ContentNotFound,
    CatatanBulkDialog
  },
  data() {
    return {
      menuDateCreated: null,
      dateCreated: [],
      filter: {
        search: null,
        kd_catatan: null,
        status: null,
        type: null
      },
      loadingUnit: false,
      loadingType: false,
      unit2: null,
      unit3: null,
      unit4: null,
      units2: [],
      units3: [],
      units4: [],
      statusList: ["NEW", "APPROVED", "REJECTED", "CANCELLED"],
      types: [],
      headers: [
        {
          text: "TANGGAL",
          value: "attendance_date",
          sortable: false,
          align: "left"
        },
        { text: "NIP", value: "NIP", sortable: false, align: "left" },
        {
          text: "UNIT KERJA",
          value: "unit_kerja",
          sortable: false,
          align: "left"
        },
        { text: "NAMA", value: "name", sortable: false, align: "left" },
        { text: "CATATAN", value: "types", sortable: false, align: "left" },
        { text: "", value: "actions", sortable: false, align: "left" }
      ],
      menu: false,
      isArchive: false,
      date: new Date().toISOString().substr(0, 7),
      selected: [],
      selection: true,
      totalItem: 0,
      pageCount: 0,
      loading: true,
      options: {
        sortBy: ["id"],
        sortDesc: [false]
      },
      rowsPerPageItems: [10, 20, 30, 40],
      notes: []
    };
  },
  computed: {
    dateCreatedText: {
      get() {
        return this.dateCreated.join(" ~ ");
      },
      set(newDate) {
        return newDate;
      }
    }
  },
  watch: {
    dateCreated(value) {
      if (value && value.length == 2) {
        this.menuDateCreated = false;
      }
    },
    options: {
      handler() {
        this.fetchListDebounce(this.getListRequestUpdate);
      },
      deep: true
    }
  },
  methods: {
    handleCreate() {
      this.$refs.catatanBulk.change(true);
    },
    handleEdit(item) {
      this.$refs.catatanBulk.edit(item.id);
    },
    changeUnit(type = 2) {
      if (type == 2) {
        this.units3 = this.units2.find(
          d => d.unit_kerja_2_id == this.unit2
        )?.unit_kerja3;
        this.unit3 = null;
        this.unit4 = null;
      } else if (type == 3) {
        this.units4 = this.units3.find(
          d => d.unit_kerja_3_id == this.unit3
        )?.unit_kerja4;
        this.unit4 = null;
      }
    },
    handleDelete(item, multiple = false) {
      this.$confirm({
        title: "Hapus Catatan",
        message: multiple
          ? `Apakah Anda yakin akan menghapus ${this.selected.length} catatan?`
          : `Apakah Anda yakin akan menghapus catatan ini?`,
        button: {
          no: "Batal",
          yes: "Hapus"
        },
        callback: confirm => {
          if (confirm) {
            var id = [];
            if (multiple) {
              this.selected.map(d => id.push(d.id));
            } else {
              id.push(item.id);
            }
            this.deleteRequestUpdate({ id });
          }
        }
      });
    },
    // Service
    async getListUnit() {
      try {
        this.loadingUnit = true;
        await PublicService.getUnitKerjaList()
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.units2 = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingUnit = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getListJenisCatatan() {
      try {
        this.loadingType = true;
        await PublicService.jenisCatatanGetList({
          type: "AT"
        })
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.types = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingType = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getListRequestUpdate() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      let orderBy = [];
      sortBy.map((d, i) => {
        let sort = sortDesc[i] ? "desc" : "asc";
        orderBy = [...orderBy, d, sort];
        return d;
      });
      try {
        this.loading = true;
        await AttendanceService.getListRequestUpdate({
          filter: {
            search: this.filter.search || "",
            start_date: this.dateCreated[0] || "",
            end_date: this.dateCreated[1] || "",
            status: this.filter.status || "",
            kd_catatan: this.filter.kd_catatan || ""
          },
          orderBy,
          pageCurrent: page,
          dataPerPage: itemsPerPage
        })
          .then(response => {
            const { status, data } = response.data;
            const { list, pageTotal, countTotal } = data;
            if (status) {
              let notes = list;
              notes.map((data, index) => {
                data.no = itemsPerPage * (page - 1) + (index + 1);
                return data;
              });

              this.notes = notes;
              this.totalItem = parseInt(countTotal);
              this.pageCount = parseInt(pageTotal);
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loading = false));
      } catch (err) {
        console.error(err);
      }
    },
    async deleteRequestUpdate(payload) {
      try {
        this.formLoading = true;
        await AttendanceService.deleteRequestUpdate(payload)
          .then(response => {
            const { status, message } = response.data;
            if (status) {
              this.getListRequestUpdate();
              this.$store.commit("snackbar/setSnack", {
                show: true,
                message: message,
                color: "success"
              });
            } else {
              this.$store.commit("snackbar/setSnack", {
                show: true,
                message: message,
                color: "error"
              });
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.formLoading = false));
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getListUnit();
    this.getListJenisCatatan();
  }
};
</script>
<style lang="scss">
#table-custom.v-data-table {
  color: #717171 !important;
  .v-data-table__wrapper > table > thead {
    background-color: #f5f6fa;
  }
  .v-data-table__wrapper > table > thead > tr > th {
    color: #a3a6b4;
    font-size: 0.775rem;
    font-weight: 400;
  }
  .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.775rem;
  }
}
#card-custom .v-input {
  font-size: 0.775rem;
}
#btn-type .v-btn--contained {
  background-color: #ffffff !important;
  .v-btn__content {
    color: #717171 !important;
  }
}
#btn-type .v-btn--active {
  background-color: #1792e6 !important;
  .v-btn__content {
    color: #ffffff !important;
  }
}
</style>
